module.exports = __webpack_public_path__ + "img/physic.6a37934c.png";